import React from 'react';
// Import styles that were used in PurchasePage
import './PurchasePage.css'; 
import './HomePage.css'; // Assuming HomePage.css might be needed for some shared styles like container
import './CustomerService.css';

function CustomerServicePage() {
  return (
    <div className="customer-service">
      <div className="container">
        <h1>購買流程和常見問題</h1>
        
        <div className="content-wrapper">
          <div className="purchase-flow">
            <h2>購買流程</h2>
            <div className="flow-steps">
              <div className="flow-step">
                <span>1</span>
                <p>選擇套餐</p>
              </div>
              <div className="flow-arrow">↓</div>
              <div className="flow-step">
                <span>2</span>
                <p>選擇支付方式</p>
              </div>
              <div className="flow-arrow">↓</div>
              <div className="flow-step">
                <span>3</span>
                <p>完成支付</p>
              </div>
              <div className="flow-arrow">↓</div>
              <div className="flow-step">
                <span>4</span>
                <p>獲取激活碼</p>
              </div>
            </div>
          </div>

          <div className="faq-section">
            <h2>常見問題</h2>
            <div className="faq-item">
              <h3>如何選擇合適的套餐？</h3>
              <p>我們提供多種套餐選擇，您可以根據自己的需求選擇合適的時長。1個月套餐適合短期試用，3個月和半年套餐性價比較高，1年套餐最為優惠。</p>
            </div>
            <div className="faq-item">
              <h3>支持哪些支付方式？</h3>
              <p>我們支持多種支付方式，包括 PayPal、USDT、微信支付和支付寶。您可以選擇最方便的支付方式完成付款。</p>
            </div>
            <div className="faq-item">
              <h3>如何獲取激活碼？</h3>
              <p>支付成功後，系統會自動生成激活碼，您可以在訂單詳情頁面查看。同時，我們也會通過郵件發送激活碼給您。</p>
            </div>
            <div className="faq-item">
              <h3>如何激活服務？</h3>
              <p>收到激活碼後，您可以在螞蟻電視的 APP 中輸入激活碼來激活服務。激活後即可立即使用所有功能。如需更換硬件，要先從舊硬件中註銷方可在新硬件中註冊。如果無法註銷，請聯繫客服從後臺註銷。</p>
            </div>
            <div className="faq-item">
              <h3>遇到問題如何聯繫客服？</h3>
              <p>您可以通過以下方式聯繫我們：<br />
              - 在線客服：工作時間 9:00-18:00<br />
              - 郵件支持：tvant2025@gmail.com<br />
              - Tg頻道：https://t.me/tvant2025</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerServicePage; 